import React from 'react';
import StarIcon from '../atoms/icons/star';

const HotelTitle = ({ hotel }) => {
  return (
    <div className="col-span-12 px-4 md:px-8 mt-0 mb-2">
      <HotelUtility hotel={hotel} textStyle="xl" />
    </div>
  );
};

export const HotelUtility = ({
  hotel,
  textStyle,
  inHotelDescription = false,
}) => {
  const textStyles = {
    xl: 'text-xl lg:text-2xl',
    lg: 'text-lg md:text-xl',
    base: 'text-base',
    marker: 'text-xs py-0',
  };

  const iconStyles = {
    xl: 'w-6 h-6 lg:w-8 lg:h-8',
    lg: 'w-4 h-4  md:w-6 md:h-6',
    base: 'w-3 h-3',
    marker: 'w-3 h-3',
  };

  const textClass = textStyles[textStyle] || textStyles.lg;
  const iconStyle = iconStyles[textStyle] || iconStyles.lg;

  return (
    <h1
      className={`${textClass} flex flex-wrap flex-col sm:flex-row text-lg ${
        inHotelDescription ? 'mt-12 mb-4' : ''
      }`}
    >
      <span className={`py-0`}>
        <span
          className={`${
            textStyle === 'base' || textStyle === 'marker' ? 'mr-2' : 'mr-4'
          }`}
        >
          {hotel.name}
        </span>

        {hotel.stars && (
          <span className={`inline-flex items-baseline pb-4 sm:pb-0`}>
            {Array.from({ length: hotel.stars }).map((_, index) => (
              <StarIcon key={index} className={`mr-1 ${iconStyle}`} />
            ))}
            {hotel.stars % 1 > 0 && (
              <StarIcon type="half" className={`mr-1 ${iconStyle}`} />
            )}
          </span>
        )}
      </span>
    </h1>
  );
};

export default HotelTitle;

//  mt-12 mb-4
